import React from 'react';
import {
  Plus, Minus, Menu, MousePointer2, Trash, Move, Image, File, StickyNote, Video,
  Download, List, Type, Check, Calendar, Grip, ChevronRight, ChevronLeft,
  MessageSquare, Heart, Code, Play, Palette, Maximize, Maximize2, Minimize,
  Home, ArrowLeft, Grid, Clock, Settings, LogOut, Star, MoreHorizontal,
  Edit, X, User, Users, Bell, Moon, Shield, RefreshCcw, Undo, Redo,
  Columns, Rows,
  BringToFront, SendToBack, Square, Eye, EyeOff, Camera, Smile, Info, Table,
  ChevronUp, ChevronDown, Upload, Sun, Monitor, Hand, ZoomIn, ZoomOut,
  Link, Unlink, ArrowRight, Lock, Unlock, Copy, Focus, Brain, Share, Send,
  FileText, Folder, RotateCw, AlertTriangle, AlertCircle, CheckSquare, Quote, Cloud,
  DollarSign, Lightbulb, HelpCircle, Mail, Pen, Pencil, Highlighter, Eraser, Pipette,
  AlignLeft, AlignCenter, AlignRight, AlignJustify,
  AlignStartVertical, AlignEndVertical, AlignCenterVertical,
  AlignStartVertical as AlignTop, AlignEndVertical as AlignBottom,
  AlignCenterVertical as AlignMiddle, ArrowLeftRight, Hexagon, Circle, Triangle, Diamond,
  ArrowUpDown, Bold, Italic, Heading, Heading1, Heading2, Underline,
  Strikethrough, Pilcrow,
  ChevronsUpDown, Ban,
  Activity, Droplets, CornerUpRight, Book, Group, Ungroup, ChevronsRight, PanelRight, QrCode,
  CheckCircle, Crosshair, Briefcase, FunctionSquare, Layout, BarChart, Braces, Printer,
  ClipboardPaste, Frame, FlipHorizontal, FlipVertical,
  Music, Figma, Map, PlayCircle, Globe, PenTool, Wand2, CopyPlus,
  Cpu,
  Loader2,
  Tag,
  Github
} from 'lucide-react';

type IconProps = React.SVGProps<SVGSVGElement>;

export const Icons = {
  Plus,
  Minus,
  Menu,
  MousePointer2,
  Trash,
  TrashSidebar: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>trash</title>
      <g fill="currentColor">
        <path d="m11,1.5h-3v-.25c0-.689-.561-1.25-1.25-1.25h-1.5c-.689,0-1.25.561-1.25,1.25v.25H1c-.414,0-.75.336-.75.75s.336.75.75.75h10c.414,0,.75-.336.75-.75s-.336-.75-.75-.75Z" fill="currentColor" strokeWidth="0"></path>
        <path d="m10.021,4.73c-.142-.147-.336-.23-.541-.23H2.519c-.204,0-.399.083-.541.23-.141.147-.217.345-.209.549l.175,4.558c.047,1.213,1.035,2.163,2.249,2.163h3.613c1.214,0,2.201-.95,2.249-2.164l.175-4.558c.008-.204-.068-.402-.209-.549Z" strokeWidth="0" fill="currentColor"></path>
      </g>
    </svg>
  ),
  Trash2: Trash,
  Move,
  Image,
  File,
  StickyNote,
  Video,
  Download,
  List,
  Type,
  Check,
  Calendar,
  Sparkles: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Prompt Library</title>
      <g clipPath="url(#clip0_56_393)">
        <path fillRule="evenodd" clipRule="evenodd" d="M2.00208 14.2502C2.00375 13.0105 3.00922 12.0063 4.24895 12.0063H15.2541C15.539 12.0063 15.7993 12.1678 15.9259 12.423C16.0526 12.6782 16.0237 12.9831 15.8514 13.21C15.3938 13.8124 15.3376 14.6346 15.8442 15.2925C16.0186 15.5189 16.0492 15.8248 15.923 16.0812C15.7968 16.3377 15.5359 16.5001 15.2501 16.5001H4.24895C3.00685 16.5001 2.0004 15.4923 2.00208 14.2502Z" fill="currentColor" fillOpacity="0.4" />
        <path fillRule="evenodd" clipRule="evenodd" d="M4.75 1.5C3.23079 1.5 2 2.73079 2 4.25V14.3176L2.00208 14.2501C2.00375 13.0104 3.00922 12.0062 4.24895 12.0062H15.2541C15.539 12.0062 15.7993 12.1677 15.9259 12.4229C15.9663 12.5042 15.9908 12.5905 16 12.6778V2.25C16 1.83579 15.6642 1.5 15.25 1.5H4.75Z" fill="currentColor" />
        <path d="M11 14H7V17.5C7 17.702 7.12199 17.885 7.30899 17.962C7.49599 18.041 7.71 17.997 7.854 17.854L9 16.708L10.146 17.854C10.242 17.95 10.37 18 10.5 18C10.564 18 10.63 17.988 10.691 17.962C10.878 17.885 11 17.702 11 17.5V14Z" fill="currentColor" />
      </g>
      <g clipPath="url(#clip1_56_393)">
        <path d="M8.10041 4.46281L7.60924 4.29908L7.44552 3.80796C7.39224 3.6493 7.12974 3.6493 7.07646 3.80796L6.91274 4.29908L6.42158 4.46281C6.34224 4.48926 6.28857 4.56354 6.28857 4.64715C6.28857 4.73076 6.34224 4.80504 6.42158 4.83148L6.91274 4.99521L7.07646 5.48638C7.10291 5.56571 7.17757 5.61937 7.26118 5.61937C7.3448 5.61937 7.41907 5.56571 7.44591 5.48638L7.60963 4.99521L8.1008 4.83148C8.18013 4.80504 8.2338 4.73076 8.2338 4.64715C8.2338 4.56354 8.17974 4.48926 8.10041 4.46281Z" fill="currentColor" />
        <path fillRule="evenodd" clipRule="evenodd" d="M9.59455 4.07764C9.71423 4.07765 9.82175 4.15078 9.86577 4.26208L10.5629 6.02559L12.3268 6.72307C12.4381 6.76708 12.5112 6.87462 12.5112 6.9943C12.5112 7.11399 12.4381 7.22153 12.3268 7.26555L10.5629 7.96299L9.86577 9.72652C9.82175 9.83782 9.71423 9.91097 9.59455 9.91097C9.47486 9.91097 9.36731 9.83786 9.3233 9.72656L8.62582 7.96303L6.86226 7.26551C6.75096 7.22153 6.67786 7.11398 6.67786 6.9943C6.67786 6.87463 6.75096 6.7671 6.86226 6.72308L8.62582 6.02559L9.3233 4.26204C9.36731 4.15074 9.47486 4.07763 9.59455 4.07764Z" fill="currentColor" />
      </g>
      <defs>
        <clipPath id="clip0_56_393">
          <rect width="18" height="18" fill="white" />
        </clipPath>
        <clipPath id="clip1_56_393">
          <rect width="7" height="7" fill="white" transform="translate(5.90002 3.30029)" />
        </clipPath>
      </defs>
    </svg>
  ),
  Grip,
  ChevronRight,
  ChevronLeft,
  ChevronsRight,
  Message: MessageSquare,
  Heart,
  Code,

  Play,
  Layers: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>layers-3</title>
      <g fill="currentColor">
        <path
          opacity="0.4"
          d="M15.6856 7.67326L9.8165 4.58299C9.3058 4.31299 8.69539 4.31251 8.18469 4.58251L2.3156 7.67326V7.6743C1.8215 7.9346 1.5148 8.44289 1.5148 9.00139C1.5148 9.55989 1.8214 10.0683 2.3156 10.3285L8.18381 13.4179C8.43971 13.5532 8.7199 13.6205 9.0007 13.6205C9.2805 13.6205 9.5608 13.5531 9.8156 13.4184L15.6857 10.3276C16.1798 10.0673 16.4865 9.55897 16.4865 9.00047C16.4865 8.44197 16.1798 7.93346 15.6856 7.67326Z"
          fill="currentColor"
        />
        <path
          opacity="0.2"
          d="M15.6856 10.9233L15.1199 10.6254L9.81552 13.4184C9.56062 13.5532 9.28031 13.6205 9.00061 13.6205C8.71981 13.6205 8.43962 13.5531 8.18372 13.4179L2.88031 10.6259L2.31552 10.9233V10.9243C1.82142 11.1846 1.51471 11.6929 1.51471 12.2514C1.51471 12.8099 1.82132 13.3183 2.31552 13.5785L8.18372 16.6679C8.43962 16.8032 8.71981 16.8705 9.00061 16.8705C9.28041 16.8705 9.56072 16.8031 9.81552 16.6684L15.6856 13.5776C16.1797 13.3173 16.4864 12.809 16.4864 12.2505C16.4864 11.692 16.1798 11.1835 15.6856 10.9233Z"
          fill="currentColor"
        />
        <path
          d="M15.6856 4.42241L9.8165 1.33208C9.3058 1.06208 8.69539 1.06159 8.18469 1.33159L2.3156 4.42241C1.8215 4.68271 1.5148 5.19197 1.5148 5.75047C1.5148 6.30897 1.8214 6.81736 2.3156 7.07756L8.18381 10.167C8.43971 10.3023 8.7199 10.3696 9.0007 10.3696C9.2805 10.3696 9.5608 10.3022 9.8156 10.1675L15.6857 7.07671C16.1798 6.81641 16.4865 6.30806 16.4865 5.74956C16.4865 5.19106 16.1798 4.68261 15.6856 4.42241Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  Palette,
  Maximize,
  Maximize2,
  Minimize,
  Home,
  ArrowLeft,
  Grid,
  Dashboard: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Dashboard</title>
      <g fill="currentColor">
        <rect x="3" y="3" width="7" height="6" rx="1" ry="1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" fill="currentColor"></rect>
        <rect x="14" y="6" width="3" height="10" rx="1" ry="1" fill="currentColor" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></rect>
        <rect x="5" y="13" width="5" height="4" rx="1" ry="1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" fill="currentColor"></rect>
      </g>
    </svg>
  ),
  Recent: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <circle cx="10" cy="10" r="7" fill="currentColor" fillOpacity="0.2" />
      <path d="M4.367 3.04395L3.771 6.79795L7.516 6.14495L4.367 3.04395Z" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10 7V10L12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M5.00004 5.101C6.27104 3.804 8.04104 3 10 3C13.866 3 17 6.134 17 10C17 13.866 13.866 17 10 17C6.47404 17 3.55604 14.392 3.07104 11" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  ),
  Clock,

  Search: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>magnifier</title>
      <g fill="currentColor">
        <path
          d="M7.75 13.25C10.7875 13.25 13.25 10.7875 13.25 7.75C13.25 4.7125 10.7875 2.25 7.75 2.25C4.7125 2.25 2.25 4.7125 2.25 7.75C2.25 10.7875 4.7125 13.25 7.75 13.25Z"
          fill="currentColor"
          fillOpacity="0.3"
          stroke="none"
        />
        <path
          d="M15.75 15.75L11.6386 11.6386"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
        <path
          d="M7.75 13.25C10.7875 13.25 13.25 10.7875 13.25 7.75C13.25 4.7125 10.7875 2.25 7.75 2.25C4.7125 2.25 2.25 4.7125 2.25 7.75C2.25 10.7875 4.7125 13.25 7.75 13.25Z"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
    </svg>
  ),
  Settings,
  LogOut,
  Star,
  StarSidebar: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>star</title>
      <g fill="currentColor">
        <path d="M16.963,6.786c-.088-.271-.323-.469-.605-.51l-4.62-.671L9.672,1.418c-.252-.512-1.093-.512-1.345,0l-2.066,4.186-4.62,.671c-.282,.041-.517,.239-.605,.51-.088,.271-.015,.57,.19,.769l3.343,3.258-.79,4.601c-.048,.282,.067,.566,.298,.734,.231,.167,.538,.189,.79,.057l4.132-2.173,4.132,2.173c.11,.058,.229,.086,.349,.086,.155,0,.31-.048,.441-.143,.231-.168,.347-.452,.298-.734l-.79-4.601,3.343-3.258c.205-.199,.278-.498,.19-.769Z" fill="currentColor"></path>
      </g>
    </svg>
  ),
  Office: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>office</title>
      <g fill="currentColor">
        <path d="M9 6.75C9 5.78379 9.78379 5 10.75 5H15.25C16.2162 5 17 5.78379 17 6.75V14.75C17 15.7162 16.2162 16.5 15.25 16.5H9.75C9.33579 16.5 9 16.1642 9 15.75V6.75Z" fill="currentColor" fillOpacity="0.4"></path>
        <path d="M2.75 8C1.78379 8 1 8.78379 1 9.75V14.75C1 15.7162 1.78379 16.5 2.75 16.5H6.75C7.16421 16.5 7.5 16.1642 7.5 15.75V9.75C7.5 8.78379 6.71621 8 5.75 8H2.75Z" fill="currentColor" fillOpacity="0.4"></path>
        <path fillRule="evenodd" clipRule="evenodd" d="M11.5 8.75C11.5 8.33579 11.8358 8 12.25 8H13.75C14.1642 8 14.5 8.33579 14.5 8.75C14.5 9.16421 14.1642 9.5 13.75 9.5H12.25C11.8358 9.5 11.5 9.16421 11.5 8.75Z" fill="currentColor"></path>
        <path fillRule="evenodd" clipRule="evenodd" d="M11.5 11.25C11.5 10.8358 11.8358 10.5 12.25 10.5H13.75C14.1642 10.5 14.5 10.8358 14.5 11.25C14.5 11.6642 14.1642 12 13.75 12H12.25C11.8358 12 11.5 11.6642 11.5 11.25Z" fill="currentColor"></path>
        <path d="M13 2.43201C13 1.21576 11.7905 0.370625 10.6482 0.788703L5.14789 2.80482C4.46015 3.05792 4 3.71236 4 4.448V8H5.75C6.71621 8 7.5 8.78379 7.5 9.75V15.75C7.5 16.1642 7.16421 16.5 6.75 16.5H9.75C9.33579 16.5 9 16.1642 9 15.75V6.75C9 5.78379 9.78379 5 10.75 5H13V2.43201Z" fill="currentColor"></path>
      </g>
    </svg>
  ),
  StarSparkle: (props: IconProps) => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <title>star-sparkle</title>
      <g fill="currentColor">
        <path d="m4.743,2.492l-.946-.315-.316-.947c-.102-.306-.609-.306-.711,0l-.316.947-.946.315c-.153.051-.257.194-.257.356s.104.305.257.356l.946.315.316.947c.051.153.194.256.355.256s.305-.104.355-.256l.316-.947.946-.315c.153-.051.257-.194.257-.356s-.104-.305-.257-.356h.001Z" fill="currentColor" strokeWidth="0"></path>
        <polyline points="13.8297 9.3765 16.25 7.0171 11.24 6.29 9 1.75 6.76 6.29 1.75 7.0171 5.375 10.551 4.519 15.54 8.2808 13.5625" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5"></polyline>
        <path d="m15.158,13.49l-1.263-.421-.421-1.263c-.137-.408-.812-.408-.949,0l-.421,1.263-1.263.421c-.204.068-.342.259-.342.474s.138.406.342.474l1.263.421.421,1.263c.068.204.26.342.475.342s.406-.138.475-.342l.421-1.263,1.263-.421c.204-.068.342-.259.342-.474s-.138-.406-.342-.474h-.001Z" fill="currentColor" strokeWidth="0"></path>
        <circle cx="14.25" cy="3.25" r=".75" fill="currentColor" strokeWidth="0"></circle>
      </g>
    </svg>
  ),
  MoreHorizontal,

  LayoutGrid: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>square-kanban</title>
      <g fill="currentColor">
        <path d="m14,2H6c-2.206,0-4,1.794-4,4v8c0,2.206,1.794,4,4,4h8c2.206,0,4-1.794,4-4V6c0-2.206-1.794-4-4-4Zm-5,12c0,.553-.447,1-1,1h-2c-.553,0-1-.447-1-1V6c0-.553.447-1,1-1h2c.553,0,1,.447,1,1v8Zm6-5c0,.553-.447,1-1,1h-2c-.553,0-1-.447-1-1v-3c0-.553.447-1,1-1h2c.553,0,1,.447,1,1v3Z" strokeWidth="0" fill="currentColor"></path>
      </g>
    </svg>
  ),
  Columns,
  Rows,
  Edit,
  X,
  User,
  Users,
  Bell,
  Moon,
  Shield,
  RefreshCcw,
  Undo,
  Redo,
  BringFront: BringToFront,
  SendBack: SendToBack,
  Square,
  Eye,
  EyeOff,
  Camera,
  Smile,
  Info,
  Table,
  ChevronUp,
  ChevronDown,
  Upload,
  Sun,
  Monitor,
  Hand,
  ZoomIn,
  ZoomOut,
  Link,
  Unlink,
  ArrowRight,
  Duplicate: CopyPlus,
  Lock,
  Unlock,
  Copy,
  Focus,
  Wand2,
  Brain,
  MessageSquare,
  Share,
  Send,
  FileText,
  Folder,
  RotateCw,
  AlertTriangle,
  AlertCircle,
  CheckSquare,
  Quote,
  Cloud,
  DollarSign,
  Lightbulb,
  HelpCircle,
  Mail,
  Pipette,
  Cpu,
  Loader2,
  Tag,
  // Removed duplicate AlertCircle and CheckCircle
  Pen, // Drawing Tools
  Pencil,
  Highlighter,
  Eraser,
  AlignLeft,
  AlignCenter,
  AlignRight,
  AlignJustify,
  AlignTop,
  AlignMiddle,
  AlignBottom,
  AlignStartVertical,
  AlignEndVertical,
  AlignCenterVertical,
  ArrowLeftRight,
  Hexagon,
  Circle,
  Triangle,
  Diamond,
  ArrowUpDown,
  Bold,
  Italic,
  Heading,
  Heading1,
  Heading2,
  Underline,
  Strikethrough,
  ChevronsUpDown,
  Pilcrow,
  Ban,
  Combine: ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect width="8" height="8" x="2" y="2" rx="2" />
      <path d="M14 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2" />
      <path d="M20 2c1.1 0 2 .9 2 2v4c0 1.1-.9 2-2 2" />
      <path d="M10 18H5c-1.7 0-3-1.3-3-3v-1" />
      <polyline points="7 21 10 18 7 15" />
      <rect width="8" height="8" x="14" y="14" rx="2" />
    </svg>
  ),
  Activity,
  Droplets,
  CornerUpRight,
  SidebarClose: ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <rect width="18" height="18" x="3" y="3" rx="2" />
      <path d="M9 3v18" />
      <path d="m16 15-3-3 3-3" />
    </svg>
  ),
  Book,
  Group,
  Ungroup,
  QrCode,
  SidebarOpen: PanelRight,
  ResizeHandle: ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M21 15v6h-6" />
      <path d="M16 21l5-5" />
    </svg>
  ),
  Fit: ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3" />
    </svg>
  ),
  ExpandWidth: ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M15 12h7" /><path d="M19 8l3 4-3 4" /><path d="M9 12H2" /><path d="M5 8l-3 4 3 4" />
    </svg>
  ),
  CollapseWidth: ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M22 12h-7" /><path d="M18 8l-3 4 3 4" /><path d="M2 12h7" /><path d="M6 8l3 4-3 4" />
    </svg>
  ),
  ColorPalette: ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <circle cx="13.5" cy="6.5" r=".5" fill="currentColor" /><circle cx="17.5" cy="10.5" r=".5" fill="currentColor" />
      <circle cx="8.5" cy="7.5" r=".5" fill="currentColor" /><circle cx="6.5" cy="12.5" r=".5" fill="currentColor" />
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.555C21.965 6.012 17.461 2 12 2z" />
    </svg>
  ),
  Convert: ({ className }: { className?: string }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className}>
      <path d="M21 12a9 9 0 0 0-9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" /><path d="M3 12a9 9 0 0 0 9 9 9.75 9.75 0 0 0 6.74-2.74L21 16" />
      <path d="M16 16h5v5" />
    </svg>
  ),
  CheckCircle,
  Crosshair,
  Briefcase,

  Bookmark: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>bookmark</title>
      <g fill="currentColor">
        <path
          d="M12.25,1H5.75c-1.517,0-2.75,1.233-2.75,2.75v12.5c0,.276,.152,.531,.396,.661,.244,.131,.54,.117,.77-.037l4.834-3.223,4.834,3.223c.125,.083,.271,.126,.416,.126,.122,0,.243-.029,.354-.089,.244-.13,.396-.385,.396-.661V3.75c0-1.517-1.233-2.75-2.75-2.75Z"
          fill="currentColor"
        />
      </g>
    </svg>
  ),
  Presentation: (props: IconProps) => (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.00004 2.66699C2.97443 2.66699 1.33337 4.30805 1.33337 6.33366V15.0003C1.33337 17.0259 2.97443 18.667 5.00004 18.667H19C21.0256 18.667 22.6667 17.0259 22.6667 15.0003V6.33366C22.6667 4.30805 21.0256 2.66699 19 2.66699H5.00004Z" fill="currentColor" fillOpacity="0.5" />
      <path d="M7.61257 18.667H9.72076L8.61533 21.9833C8.44069 22.5071 7.87437 22.7903 7.35043 22.6157C6.82648 22.441 6.54332 21.8747 6.71797 21.3507L7.61257 18.667Z" fill="currentColor" />
      <path d="M14.2793 18.667H16.3874L17.282 21.3507C17.4566 21.8747 17.1736 22.441 16.6496 22.6157C16.1256 22.7903 15.5593 22.5071 15.3846 21.9833L14.2793 18.667Z" fill="currentColor" />
      <path d="M13 1.8335C13 1.28121 12.5523 0.833496 12 0.833496C11.4477 0.833496 11 1.28121 11 1.8335V2.66683H13V1.8335Z" fill="currentColor" />
      <path d="M9 7.50288C9 6.26681 10.4115 5.56104 11.4004 6.30268L15.4004 9.30268C16.2001 9.90268 16.2002 11.1031 15.4004 11.7031L11.4004 14.7031L11.3057 14.7675C10.3556 15.3787 9.085 14.7439 9.0039 13.6172L9 13.5029V7.50288ZM9.75 13.5029C9.7502 14.1208 10.4558 14.4733 10.9502 14.1025L14.9502 11.1025C15.35 10.8025 15.3501 10.2023 14.9502 9.90228L10.9502 6.90229C10.4558 6.53154 9.75 6.88487 9.75 7.50288V13.5029Z" fill="url(#pres_paint0)" />
      <path d="M9 13.502C9 14.7381 10.4115 15.4438 11.4004 14.7022L15.4004 11.7022C16.2001 11.1022 16.2002 9.9018 15.4004 9.3018L11.4004 6.3018L11.3057 6.2374C10.3556 5.6262 9.085 6.261 9.0039 7.3877L9 7.502V13.502ZM9.75 7.502C9.7502 6.8841 10.4558 6.5316 10.9502 6.9024L14.9502 9.9024C15.35 10.2024 15.3501 10.8026 14.9502 11.1026L10.9502 14.1026C10.4558 14.4733 9.75 14.12 9.75 13.502V7.502Z" fill="url(#pres_paint1)" />
      <defs>
        <linearGradient id="pres_paint0" x1="12.5" y1="5.99968" x2="12.5" y2="11.2147" gradientUnits="userSpaceOnUse">
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
        <linearGradient id="pres_paint1" x1="12.5" y1="15.0052" x2="12.5" y2="9.7902" gradientUnits="userSpaceOnUse">
          <stop stopColor="currentColor" />
          <stop offset="1" stopColor="currentColor" stopOpacity="0" />
        </linearGradient>
      </defs>
    </svg>
  ),
  FunctionSquare,
  Layout,
  BarChart,
  Braces,
  Printer,
  ClipboardPaste,
  Frame,
  FlipHorizontal,
  FlipVertical,
  Music,
  Figma,
  Map,
  PlayCircle,
  Globe,
  PenTool,
  DevTool: (props: IconProps) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" {...props}>
      <title>window-code-2</title>
      <g fill="currentColor">
        <path d="m14,3H6c-1.657,0-3,1.343-3,3v2h14v-2c0-1.657-1.343-3-3-3Zm-8,3c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Zm3,0c-.552,0-1-.448-1-1s.448-1,1-1,1,.448,1,1-.448,1-1,1Z" strokeWidth="0" fill="currentColor"></path>
        <polyline points="12.5 12 10 14.5 12.5 17" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></polyline>
        <path d="m17,8.845v-2.845c0-1.657-1.343-3-3-3H6c-1.657,0-3,1.343-3,3v8c0,1.657,1.343,3,3,3h1.55l-.025-.025" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></path>
        <polyline points="15.5 17 18 14.5 15.5 12" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2"></polyline>
      </g>
    </svg>
  ),
  Github
};

export type IconKey = keyof typeof Icons;
